import React, { useState } from 'react';
import ForecastDaily, { DailyForecast } from './ForecastDaily';
import Layout from './Layout';
import Location from './Location';
import LocationSelector from './LocationSelector';
import Temperature from './Temperature';

import * as styles from './WeatherWidget.module.scss';

export interface CurrentWeather {
  temp: number;
  description: string;
  date: number;
}

interface WeatherWidgetProps {
  cities: Array<{ name: string; id: number }>;
  currentCityId: number;
  onCitySelect: (cityId: number) => void;
  currentCondition: CurrentWeather;
  forecastDaily: Array<DailyForecast>;
}

const WeatherWidget = ({
  cities,
  currentCityId,
  onCitySelect,
  currentCondition,
  forecastDaily,
}: WeatherWidgetProps): React.ReactElement => {
  const [locationSelectorOpen, setLocationSelectorOpen] = useState(false);

  return (
    <Layout>
      <Location
        onClick={() => setLocationSelectorOpen(true)}
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        location={cities.find(city => city.id === currentCityId)!.name}
      />

      <Temperature weather={currentCondition.description} temperature={currentCondition.temp} />
      <section className={styles.forecastsWrapper}>
        <div className={styles.forecasts}>
          <ForecastDaily dailyForecasts={forecastDaily} />
        </div>
      </section>
      <LocationSelector
        open={locationSelectorOpen}
        cities={cities}
        currentCityId={currentCityId}
        onCitySelect={onCitySelect}
        onClose={() => setLocationSelectorOpen(false)}
      ></LocationSelector>
    </Layout>
  );
};

export default WeatherWidget;
